"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MissingMetersPrompt = MissingMetersPrompt;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@heroui/react");
var react_2 = require("@iconify/react");
var react_3 = require("react");
var meter_premise_config_1 = require("../../../features/apis/meter-premise-config");
var hooks_1 = require("../../../store/hooks");
/*
 * MC&LCC-3.3 — the backlog prompt.
 *
 * Confirming a building area used only to MOVE meters onto it, never to create them. On an asset Cue
 * held no meters for, that produced the state Erik reported: 56 premises marked "Confirmed", every
 * meter reading "not in Let'sCue", and no metering data reaching billing.
 *
 * Creating them is fixed, but the fix only runs when a premise is confirmed — and nothing on the
 * screen would tell anyone that a row already showing "Confirmed" needs confirming again. The reason
 * is historical, not visible, and re-applying a ctrl+click gesture to fifty-odd rows that already
 * look finished is not a thing a user would think to do.
 *
 * So the screen states the problem in its own terms and offers one button. It renders nothing at all
 * once there is no backlog, so it disappears the moment it stops being true rather than becoming
 * furniture people learn to ignore.
 */
function MissingMetersPrompt(_a) {
    var _this = this;
    var _b, _c, _d, _e;
    var clientId = _a.clientId, buildingId = _a.buildingId;
    var userId = (0, hooks_1.useAppSelector)(function (state) { return state.auth; }).userId;
    var _f = (0, meter_premise_config_1.useFetchMissingMetersQuery)({ clientId: clientId, buildingId: buildingId }, { skip: !clientId || !buildingId }), data = _f.data, isLoading = _f.isLoading, refetch = _f.refetch;
    var _g = (0, meter_premise_config_1.useCreateMissingMetersMutation)(), createMissing = _g[0], isCreating = _g[1].isLoading;
    var _h = (0, react_3.useState)(null), done = _h[0], setDone = _h[1];
    var premises = (_c = (_b = data === null || data === void 0 ? void 0 : data.content) === null || _b === void 0 ? void 0 : _b.premises) !== null && _c !== void 0 ? _c : [];
    var meterCount = (_e = (_d = data === null || data === void 0 ? void 0 : data.content) === null || _d === void 0 ? void 0 : _d.meterCount) !== null && _e !== void 0 ? _e : 0;
    // Nothing outstanding — say nothing.
    if (isLoading || (!premises.length && !done))
        return null;
    var run = function () { return __awaiter(_this, void 0, void 0, function () {
        var res, r, e_1, message;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, createMissing({ clientId: clientId, buildingId: buildingId, performedBy: userId }).unwrap()];
                case 1:
                    res = _b.sent();
                    r = res.content;
                    if (r.failures.length) {
                        (0, react_1.addToast)({
                            title: "Some meters could not be created",
                            description: r.failures.slice(0, 3).join(" · "),
                            color: "warning",
                        });
                    }
                    setDone("".concat(r.metersCreated, " meter").concat(r.metersCreated === 1 ? "" : "s", " created across ").concat(r.premisesDone, " premise").concat(r.premisesDone === 1 ? "" : "s", "."));
                    void refetch();
                    return [3 /*break*/, 3];
                case 2:
                    e_1 = _b.sent();
                    message = ((_a = e_1 === null || e_1 === void 0 ? void 0 : e_1.data) === null || _a === void 0 ? void 0 : _a.message) || "Could not create the meters.";
                    (0, react_1.addToast)({ title: "Could not create the meters", description: message, color: "danger" });
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    if (done && !premises.length) {
        return ((0, jsx_runtime_1.jsx)(react_1.Alert, { color: "success", title: "Meters created", children: (0, jsx_runtime_1.jsxs)("p", { className: "text-[13px]", children: [done, " They are now billable objects like any other meter, and will appear under Meters."] }) }));
    }
    return ((0, jsx_runtime_1.jsx)(react_1.Alert, { color: "warning", title: "".concat(premises.length, " confirmed ").concat(premises.length === 1 ? "area has" : "areas have", " meters that are not in Let'sCue yet"), children: (0, jsx_runtime_1.jsxs)("div", { className: "flex min-w-0 flex-col gap-2", children: [(0, jsx_runtime_1.jsxs)("p", { className: "min-w-0 break-words text-[13px] leading-relaxed", children: ["The metering company reports ", (0, jsx_runtime_1.jsx)("strong", { children: meterCount }), " meter", meterCount === 1 ? "" : "s", " for", " ", premises.length === 1 ? "this area" : "these areas", ", but Cue has no record of ", meterCount === 1 ? "it" : "them", " \u2014 so none of their readings can reach billing. Creating them brings each one in with its make, model, supplier and connection size, assigns it to its area, and applies the billing rules."] }), (0, jsx_runtime_1.jsxs)("p", { className: "min-w-0 break-words text-[12px] text-gray-500", children: ["For example: ", premises.slice(0, 3).map(function (p) { var _a; return "".concat((_a = p.areaName) !== null && _a !== void 0 ? _a : p.premiseName, " (").concat(p.missingSerials.length, ")"); }).join(", "), premises.length > 3 ? ", and ".concat(premises.length - 3, " more") : "", "."] }), (0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(react_1.Button, { size: "sm", color: "warning", isDisabled: isCreating, startContent: isCreating ? (0, jsx_runtime_1.jsx)(react_1.Spinner, { size: "sm" }) : (0, jsx_runtime_1.jsx)(react_2.Icon, { icon: "solar:download-minimalistic-linear" }), onPress: run, children: isCreating ? "Creating…" : "Create ".concat(meterCount, " meter").concat(meterCount === 1 ? "" : "s") }) })] }) }));
}
